import { render, staticRenderFns } from "./SimpleFileInput.vue?vue&type=template&id=1496003e&"
import script from "./SimpleFileInput.vue?vue&type=script&lang=ts&"
export * from "./SimpleFileInput.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleFileInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports